import React from 'react';

import GestionnairesCopro from '../../components/Analyzing/GestionnairesCopro';

function GestionnairesCoproView() {
  return (
    <GestionnairesCopro />
  );
}

export default GestionnairesCoproView;
